module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6ERSEf/tc-custom/9781442465428.jpg?1730535436257",
      "alt": "This image is the cover for the book Close Encounters, Nancy Drew Girl Detective"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Close Encounters, Nancy Drew Girl Detective\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Could aliens actually exist in small-town Vermont? Nancy suspects not...")]), _c('br'), _c('br'), _vm._v("Nancy, Bess and George have driven from River Heights to northern Vermont to visit a friend of George and her mom's who owns a quaint, touristy small restaurant/café in a town near a major ski resort. They are amazed that though it is past the height of foliage season, and barely ski season, there is a traffic jam of cars waiting to catch a ferry; they decide to drop out of line and drive to a local diner. When they question the waitress about what is going on, she is surprised they haven't heard but there have been repeated and credible UFO sightings over the border in ski country in Vermont. George jokes about little green men in snowsuits. Bess suggests the men are red but wearing green snowsuits. Nancy simply cracks up, but grows serious when the waitress reveals that even Federal government investigators have been called in--\"Vermont is turning into a North Country Roswell, New Mexico!\" It's been great for business, here and throughout northern Vermont, particularly for the town at the foot of the ski resort, but we're all getting a little tired of the crowds, the waitress confides.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carolyn Keene\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Carolyn Keene is the author of the ever-popular Nancy Drew books.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Aladdin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0